export default __webpack_public_path__ + "static/media/masha.5aa4e45e.png";